import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import {
  Box,
  Typography,
  Stack,
  TextField,
  InputAdornment,
  IconButton,
  CircularProgress,
  Alert,
  Paper,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Tooltip
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import DescriptionIcon from "@mui/icons-material/Description";

import ModalDescripcion from "../componentes/modaldescripcion"; // Modal separado

export default function DescripcionPage() {
  const [descripciones, setDescripciones] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");
  const [empresaId, setEmpresaId] = useState(null);

  const API_LISTAR_DESCRIPCION = "https://demo.datachile.site/API/web/obtener_descripcion.php";
  const API_ELIMINAR_DESCRIPCION = "https://demo.datachile.site/API/web/eliminar_descripcion.php";

  useEffect(() => {
    const storedUser = localStorage.getItem("usuario");
    if (storedUser) setEmpresaId(JSON.parse(storedUser).empresa_idempresa);
  }, []);

  useEffect(() => {
    if (empresaId) listarDescripciones();
  }, [empresaId]);

  const listarDescripciones = async () => {
    try {
      setLoading(true);
      const res = await axios.get(API_LISTAR_DESCRIPCION, { params: { empresa_idempresa: empresaId } });
      setDescripciones(res.data);
    } catch (err) {
      console.error(err);
      setError("Error al cargar descripciones");
    } finally {
      setLoading(false);
    }
  };

const eliminarDescripcion = async (idDescripcion) => {
  if (!window.confirm("¿Eliminar descripción?")) return;

  try {
    const data = new FormData();
    data.append("idDescripcion", idDescripcion);

    const res = await axios.post(API_ELIMINAR_DESCRIPCION, data);

    // Aquí res.data es la respuesta que envía PHP
    // Por ejemplo: { message: 'Descripción eliminada con éxito' }
    alert(res.data.message); // muestra el mensaje del servidor

    // Refrescar tabla
    listarDescripciones();
  } catch (err) {
    console.error(err);

    // Si el error viene del servidor con status code y mensaje
    if (err.response && err.response.data && err.response.data.message) {
      setError(err.response.data.message);
    } else {
      setError("Error al eliminar descripción");
    }
  }
};

  const filteredData = useMemo(() => {
    return descripciones.filter((d) =>
      d.descripcion.toLowerCase().includes(search.toLowerCase())
    );
  }, [descripciones, search]);

  return (
    <Box sx={{ p: 3 }}>
      {/* HEADER */}
      <Stack
        direction={{ xs: "column", md: "row" }}
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
        sx={{ mb: 3 }}
      >
        <Box>
          <Typography variant="h4" fontWeight={700}>
            Descripciones
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Administración y gestión de descripciones de productos
          </Typography>
        </Box>

        <Stack direction="row" spacing={2}>
          <TextField
            size="small"
            placeholder="Buscar descripción..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
          <ModalDescripcion empresaId={empresaId} actualizarTabla={listarDescripciones} />
        </Stack>
      </Stack>

      {/* ERROR */}
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

      {/* LOADING */}
      {loading ? (
        <Box display="flex" justifyContent="center" mt={4}>
          <CircularProgress />
        </Box>
      ) : (
        <Paper sx={{ borderRadius: 3, overflow: "hidden", boxShadow: "0 4px 20px rgba(0,0,0,0.05)" }}>
          <Table>
            <TableHead>
              <TableRow sx={{ background: "linear-gradient(90deg, #1976d2, #42a5f5)" }}>
                <TableCell sx={{ color: "#fff", fontWeight: 600 }}>ID</TableCell>
                <TableCell sx={{ color: "#fff", fontWeight: 600 }}>Descripción</TableCell>
                <TableCell sx={{ color: "#fff", fontWeight: 600 }}>Código</TableCell>
                <TableCell sx={{ color: "#fff", fontWeight: 600 }}>Acciones</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredData.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    No se encontraron descripciones
                  </TableCell>
                </TableRow>
              ) : (
                filteredData.map((d) => (
                  <TableRow key={d.idDescripcion} sx={{ "&:hover": { backgroundColor: "rgba(25, 118, 210, 0.08)" } }}>
                    <TableCell>{d.idDescripcion}</TableCell>
                    <TableCell>{d.descripcion}</TableCell>
                    <TableCell>{d.codigo}</TableCell>
                    <TableCell>
                      <Stack direction="row" spacing={1}>
                        <Tooltip title="Eliminar">
                          <IconButton color="error" onClick={() => eliminarDescripcion(d.idDescripcion)}>
                            <DeleteForeverIcon />
                          </IconButton>
                        </Tooltip>
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </Paper>
      )}
    </Box>
  );
}